import styled from "styled-components";
import { theme } from "../theme";

export const AddMinuteContainer = styled.div`
	& > div:not(:first-child) label {
		display: block;
		margin-top: 1rem;
	}
`;

export const AgendaButtonsContainer = styled.div`
	display: flex;
	column-gap: 1rem;

	position: absolute;
	bottom: -2.5rem;
	left: 0.8rem;
`;

export const AgendaButton = styled.button`
	padding: 0.5rem 1.5rem;

	background-color: transparent;
	border: 1px solid ${(props) => (props.active ? `${theme.color.green}` : `${theme.color.blue2}`)};
	border-radius: 5rem;

	display: flex;
	column-gap: 0.75rem;
	color: ${(props) => (props.active ? `${theme.color.green}` : `${theme.color.blue2}`)};
	font-family: ${theme.font.secondary};

	cursor: pointer;
`;

export const AgendaPoint = styled.div`
	margin-bottom: 1.6rem;

	& h4 {
		font-size: 1.4rem;
		font-weight: 700;
	}

	& p {
		margin-top: 0.5rem;
		font-size: 1.4rem;
		font-weight: 300;
	}

	& h5 {
		margin-top: 0.5rem;

		font-size: 1.4rem;
		font-weight: 500;
	}
`;
